export const tedeeConfig = {
  common: {
    saving: "Wird gespeichert...",
    connected: "Verbunden",
    disconnected: "Getrennt",
    lockFallbackNamed: "Schloss {id}",
    deviceFallbackNamed: "Tedee-Gerät {id}",
    unitFallback: "Einheit",
    unitFallbackNamed: "Einheit {id}",
  },

  credentials: {
    title: "Tedee-Konfiguration",
    apiVersionInUse: "Verwendete API-Version:",
    savedKey: "Schlüssel gespeichert",
    noKey: "Kein Schlüssel",
    keyLabel: "Personal Access Key",
    keyPlaceholderSaved: "•••••••• (gespeichert, Änderung optional)",
    keyPlaceholderNew: "Geben Sie Ihren Tedee Personal Access Key ein",
    keyHintSaved: "Sie können das Feld leer lassen, wenn bereits ein Schlüssel gespeichert ist.",
    keyHintNew: "Ihren Schlüssel erhalten Sie im Tedee-Portal.",
    testing: "Wird getestet...",
    test: "Verbindung testen",
    save: "Zugangsdaten speichern",
  },

  selector: {
    title: "Schlossauswahl für diese Unterkunft",
    subA: "Wählen Sie nur die Schlösser aus, die gehören zu",
    subBold: "dieser Unterkunft",
    subB: ". Danach sehen Sie im PMS nur die ausgewählten.",
    selectedCount: "{count} ausgewählt",
    hintNoKeyA: "Geben Sie Ihren Personal Access Key ein und drücken Sie",
    hintNoKeyBold: "Verbindung testen",
    hintNoKeyB: ", um Ihre Schlösser zu laden.",
    emptyDevices:
      "Wir konnten in Ihrem Tedee-Konto kein Schloss und kein Tor finden. Stellen Sie sicher, dass das Gerät registriert und für das Konto freigegeben ist, dessen Schlüssel Sie oben gespeichert haben.",
    placeholder: "Schlösser auswählen…",
    summaryCount: "{count} Schloss/Schlösser ausgewählt",
    summaryEmpty: "Keine Schlösser ausgewählt",
    save: "Schlösser für diese Unterkunft speichern",
  },

  pms: {
    title: "Steuerung und Zuordnung (PMS)",
    subA:
      "Hier erscheinen nur die Schlösser, die Sie für diese Unterkunft gespeichert haben. Ordnen Sie jedes zu als",
    subBold1: "Haupttür",
    subOr: "oder",
    subBold2: "Einheit",
    subEnd: ".",
    assignedCount: "{count} zugeordnet",
    empty: {
      A: "Sie haben für diese Unterkunft noch keine Schlösser gespeichert. Nutzen Sie die",
      bold: "Auswahl",
      B: "oben und speichern Sie dann.",
    },
    assignmentLabel: "Zuordnung",
    assignmentNone: "Nicht zugeordnet",
    assignmentGate: "Haupttür (Gate)",
    assignmentCommon: "Haupttür (gemeinsam)",
    assignmentUnit: "Wohnungstür",
    hintNone: "Es wird nicht über das PMS gesteuert.",
    hintGate: "Gate: Es kann nur zum Öffnen betätigt werden (kein Verriegeln, keine PINs).",
    hintUnit: "Es wird für Steuerung und PINs mit dieser Unterkunft verknüpft.",
    unitLabel: "Einheit / Unterkunft",
    unitSelect: "Einheit auswählen",
    unitHint: "Wählen Sie aus, welche Einheit dieses Schloss öffnet.",
    nameLabel: "Name (optional)",
    namePlaceholder: "Z. B. Haupttür / Apt. 101",
    nameHint: "Dieser Name wird gespeichert, wenn Sie die Schlossauswahl erneut speichern.",
    actions: {
      lock: "Verriegeln",
      unlock: "Entriegeln",
      createPin: "PIN erstellen",
      pinHistory: "PIN-Verlauf",
      openGate: "Tor öffnen (Impuls)",
      refresh: "Status aktualisieren",
    },
    save: "Zuordnung speichern",
    tipA: "Tipp: Ordnen Sie eine Haupttür oder Einheit zu und drücken Sie",
    tipBold: "Zuordnung speichern",
    tipB: ". Die Schaltflächen werden aktiv, sobald das Gerät zugeordnet ist.",
  },

  pinHistory: {
    title: "PIN-Verlauf",
    loading: "Verlauf wird geladen…",
    empty: "Für dieses Schloss sind keine PINs erfasst.",
    colAlias: "Alias",
    colPin: "PIN",
    colValidity: "Gültigkeit",
    colState: "Status",
    createdPrefix: "Erstellt:",
    fromLabel: "Von:",
    toLabel: "Bis:",
    revokeTitle: "PIN löschen / widerrufen",
    noteA: '* "Aktiv" wird berechnet, indem das aktuelle Datum und die Uhrzeit verglichen werden mit',
    noteMid: "und",
    noteEnd: ".",
    close: "Schließen",
  },

  pinModal: {
    title: "PIN erstellen",
    nameLabel: "Name / Bezeichnung",
    namePlaceholder: "Z. B. Reinigung / Gast / Techniker",
    pinLabel: "PIN",
    pinPlaceholder: "6 Ziffern",
    generateTitle: "Generieren",
    pinHint: "Wenn Sie das Feld leer lassen, generiert das Backend eine PIN.",
    modeLabel: "Modus",
    modeTimeLimited: "Mit Daten",
    modeOngoing: "Ohne Daten (bis zum Widerruf)",
    validFrom: "Gültig ab",
    validTo: "Gültig bis",
    tipLabel: "Tipp:",
    tipText: "Nutzen Sie für einen Gast eine PIN mit Check-in- und Check-out-Daten.",
    cancel: "Abbrechen",
    creating: "Wird erstellt...",
    create: "PIN erstellen",
  },

  toast: {
    noLocksFound: "In Tedee wurden keine Schlösser (Typ 2/5) gefunden.",
    loadStatusError: "Der Schlossstatus konnte nicht geladen werden",
    loadStatusError2: "Fehler beim Laden des Schlossstatus",
    needKey: "Sie müssen einen Personal Access Key eingeben oder einen gespeicherten Schlüssel haben.",
    connectionOk: "Verbindung erfolgreich. {count} Gerät(e) gefunden.",
    testError: "Fehler beim Testen der Verbindung",
    needValidKey:
      "Sie müssen einen gültigen Personal Access Key eingeben (mindestens 10 Zeichen).",
    credentialsSaved: "Zugangsdaten erfolgreich gespeichert",
    saveCredentialsError: "Fehler beim Speichern der Zugangsdaten",
    saveCredentialsErrorPrefix: "Fehler beim Speichern der Zugangsdaten: ",
    needOneDevice: "Sie müssen mindestens ein Gerät für diese Unterkunft auswählen.",
    devicesSaved: "Geräte für diese Unterkunft gespeichert",
    devicesSaveError: "Die Geräte konnten nicht gespeichert werden",
    saveErrorPrefix: "Fehler beim Speichern: ",
    gateNoLock:
      "Gate (Typ 5) unterstützt kein Verriegeln. Es kann nur zum Öffnen betätigt werden.",
    locked: "Schloss verriegelt",
    lockError: "Verriegeln nicht möglich",
    lockError2: "Fehler beim Verriegeln",
    gateOpened: "Tor geöffnet (Impuls)",
    unlocked: "Schloss entriegelt",
    unlockError: "Entriegeln nicht möglich",
    unlockError2: "Fehler beim Entriegeln",
    needUnitForApartment:
      "Wählen Sie die Einheit für die als 'Wohnungstür' zugeordneten Schlösser aus.",
    bindingsSaved: "Zuordnung erfolgreich gespeichert",
    bindingsSaveError: "Die Zuordnung konnte nicht gespeichert werden",
    bindingsSaveErrorPrefix: "Fehler beim Speichern der Zuordnung: ",
    gateNoPin: "Gate (Typ 5) unterstützt keine PINs.",
    assignFirst:
      "Ordnen Sie das Schloss zuerst zu (Haupttür oder Einheit) und speichern Sie, um die Steuerung zu aktivieren.",
    needPinName: "Sie müssen einen Namen bzw. eine Bezeichnung für die PIN angeben.",
    needValidDates: "Sie müssen ein Gültig-ab- und ein Gültig-bis-Datum angeben.",
    pinCreated: "PIN erfolgreich erstellt",
    pinCreateError: "Die PIN konnte nicht erstellt werden",
    pinCreateError2: "Fehler beim Erstellen der PIN",
    gateNoPinHistory: "Gate (Typ 5) unterstützt keinen PIN-Verlauf.",
    historyLoadError: "Der Verlauf konnte nicht geladen werden",
    historyLoadError2: "Fehler beim Laden des Verlaufs",
    noProviderPinId:
      "Diese PIN hat keine provider_pin_id. Sie kann in Tedee nicht widerrufen werden.",
    pinRevoked: "PIN widerrufen",
    revokeError: "Widerrufen nicht möglich",
    revokeError2: "Fehler beim Widerrufen der PIN",
  },

  confirm: {
    revokePin: 'Möchten Sie die PIN "{alias}" wirklich widerrufen/löschen?',
  },

  pinState: {
    active: "Aktiv",
    upcoming: "Bevorstehend",
    expired: "Abgelaufen",
    revoked: "Widerrufen",
    none: "Ohne Daten",
  },
};
